import { motion } from "framer-motion";
import { Globe, ShieldCheck, Plane, BadgeCheck, Headphones, Sparkles } from "lucide-react";

const ICONS = { Globe, ShieldCheck, Plane, BadgeCheck, Headphones, Sparkles };

const ITEMS = [
  { title: "Fully Online Platform", desc: "Browse, brief, approve and reorder — all from a single dashboard.", icon: "Globe" },
  { title: "Top-Quality Network", desc: "A vetted UAE production network with quality controls at every step.", icon: "ShieldCheck" },
  { title: "Worldwide Delivery", desc: "From Dubai to anywhere — courier handling and customs sorted.", icon: "Plane" },
  { title: "Quality + Value", desc: "Premium materials at transparent prices — no hidden overheads.", icon: "BadgeCheck" },
  // { title: "24/7 Customer Support", desc: "Project managers on chat, email and phone around the clock.", icon: "Headphones" },
  { title: "Creativity & Experience", desc: "5+ years and 500+ projects of design-led production craft.", icon: "Sparkles" },
];

export default function PrintzeeAdvantage() {
  return (
    <section id="advantage" data-testid="advantage-section" className="bg-white dark:bg-[#0B1120] py-24 md:py-32 transition-colors">
      <div className="pz-container">
        <div className="max-w-3xl">
          <span className="pz-overline">The Printzee Advantage</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] dark:text-white">
            Six promises we<br />never compromise on.
          </h2>
          <div className="pz-gold-line mt-6" />
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map((it, i) => {
            const Icon = ICONS[it.icon];
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`advantage-card-${i}`}
                className="group relative rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.03] p-7 hover:-translate-y-1.5 hover:shadow-2xl hover:border-[#F59E0B]/40 transition-all"
              >
                <div className="w-12 h-12 rounded-xl bg-[#0F172A] dark:bg-[#F59E0B] text-white dark:text-[#0F172A] grid place-items-center group-hover:bg-[#F59E0B] group-hover:text-[#0F172A] transition-colors">
                  <Icon className="w-5 h-5" strokeWidth={1.6} />
                </div>
                <h3 className="mt-6 font-display text-xl font-semibold text-[#0F172A] dark:text-white">{it.title}</h3>
                <p className="mt-3 text-slate-600 dark:text-white/65 text-sm leading-relaxed">{it.desc}</p>
                <div className="mt-6 h-[1px] w-10 bg-[#F59E0B] group-hover:w-20 transition-all duration-500" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
